<template>
  <div
    class="before:h-56 before:w-full before:absolute before:z-0
    before:bg-gradient-to-b before:from-blue before:to-midBlue
    children:z-10 children:relative"
    :class="{'before-bg-colour': colour}"
    :style="cssProps"
  >
    <img
      :src="logo || defaultLogo"
      alt="Signable"
      class="w-40 min-h-24 max-h-28 mx-auto py-6 object-contain"
    />
    <slot />
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

import defaultLogo from '@/assets/signable.svg'

const props = defineProps({
  logo: String,
  colour: String
})

const cssProps = computed(() => ({
  '--colour': props.colour
}))
</script>

<style scoped>
.before-bg-colour::before {
  background: var(--colour);
}
</style>
